<template>
  <div id="app" :class="{ grayscale: ebo }">
    <!-- <headbox name="head"></headbox> -->
    <router-view :key="new Date().getTime()" />
    <!-- <footbox name="foot"></footbox> -->
  </div>
</template>
<script type="text/javascript">
document.write(
  unescape(
    "%3Cspan id='cnzz_stat_icon_1280957522'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/z_stat.php%3Fid%3D1280957522%26show%3Dpic2' type='text/javascript'%3E%3C/script%3E"
  )
);
</script>
<script>
import { detail } from "@/api/index.js";
export default {
  data() {
    return {
      hfliat: [],
      ebo: false,
    };
  },
  created() {
    this.handleheadfoot();
  },
  methods: {
    // 头部数据
    handleheadfoot() {
      detail(5).then((res) => {
        this.hfliat = JSON.parse(res.data.data.config);
        this.ebo = this.hfliat.ebo;
        //
      });
    },
  },
  components: {
    // headbox,
    // footbox,
  },
  updated() {
    window.scroll(0, 0);
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #fcfcfc;
  font-family: Microsoft YaHei;
}
img {
  object-fit: cover;
}
.grayscale {
  filter: grayscale(100%);
}
// 单行显示
.one-line {
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
// 显示多行
.two-line,
.three-line,
.f-line {
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.two-line {
  -webkit-line-clamp: 2;
}
.three-line {
  -webkit-line-clamp: 3;
}
.f-line {
  -webkit-line-clamp: 4;
}
</style>
